/**
 * @description
 * Метод для получения url фото товара
 */

export default (image, pictureSource, attrName) => {
  let url = image.original_url;

  const resizingRulesIndex = pictureSource.dataset[attrName];
  if (resizingRulesIndex && image.resized_urls) {
    const resized_url = image.resized_urls[resizingRulesIndex];
    if (resized_url) { url = resized_url; }
  }

  return url;
};
